import { render, staticRenderFns } from "./ProjectMethodParameters.vue?vue&type=template&id=555a8134"
import script from "./ProjectMethodParameters.vue?vue&type=script&lang=js"
export * from "./ProjectMethodParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports